module.exports = `${require.publicPath}201.7ddd9510.png`;